"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var VariablesCondition = function VariablesCondition(_ref) {
  var errors = _ref.errors;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "calculateCondition",
    label: "Variables",
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        field: field,
        form: form,
        label: "Calculate condition"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "radio",
        value: "all",
        checked: form.values.calculateCondition === 'all',
        onChange: function onChange() {
          form.setFieldValue('calculateCondition', 'all');
        }
      }), ' ', "all selected variables must be answered")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "radio",
        value: "minimum",
        checked: form.values.calculateCondition === 'minimum',
        onChange: function onChange() {
          form.setFieldValue('calculateCondition', 'minimum');
        }
      }), ' ', "at least", ' ', /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-control input-sm",
        style: {
          display: 'inline-block',
          width: '60px',
          height: '1.8em'
        },
        type: "number",
        min: "1",
        value: form.values.minimumAnswers,
        onChange: function onChange(e) {
          form.setFieldValue('minimumAnswers', Number(e.target.value));
        }
      }), ' ', "must be answered")));
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "control-label"
  }, "Ignore values outside this range:"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "minimum",
    render: function render(_ref3) {
      var field = _ref3.field,
        form = _ref3.form;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-group"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-addon"
      }, "Min"), /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-control",
        type: "number",
        style: {
          width: '5em'
        }
      }, field)));
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "maximum",
    render: function render(_ref4) {
      var field = _ref4.field,
        form = _ref4.form;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-group",
        style: {
          marginLeft: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-addon"
      }, "Max"), /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-control",
        type: "number",
        style: {
          width: '5em'
        }
      }, field)));
    }
  })), errors.minimum && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-danger",
    style: {
      marginTop: '0.3em'
    }
  }, errors.minimum)));
};
VariablesCondition.propTypes = {
  errors: _propTypes["default"].object
};
var _default = VariablesCondition;
exports["default"] = _default;